module.exports = __webpack_public_path__ + "img/404.d4f73e06.png";